if ($('.fotorama').length) {
  $(document).ready(function() {
    // Initialize Fotorama with responsive navigation configuration
    const isMobile = window.innerWidth <= 768;

    const fotoramaDiv = $('.fotorama').fotorama({
      nav: 'thumbs', // Always show thumbs navigation
      thumbspreview: false,
      allowfullscreen: true,
      arrows: true,
      swipe: true,
      // Configure for vertical thumbs on desktop
      thumbwidth: 100,
      thumbheight: 100,
      thumbmargin: 8,
      thumbborderwidth: 2
    });

    const fotorama = fotoramaDiv.data('fotorama');

    // The CSS "vertical thumbs" hack locks the nav shaft's transform/transition
    // (see .fotorama__nav .fotorama__nav__shaft { transform: none !important })
    // so users scroll the nav-wrap natively instead of Fotorama moving the shaft.
    // Fotorama only fills in <img> src for thumbs it thinks are "visible" based on
    // that shaft position, so thumbs beyond its initial visible window never load
    // and render as blank frames. Force-fill any thumb Fotorama skipped.
    function forceLoadNavThumbs() {
      if (!fotorama || !fotorama.data) return;
      const frames = document.querySelectorAll('.fotorama__nav__frame--thumb');
      fotorama.data.forEach(function(item, i) {
        const frame = frames[i];
        if (!frame) return;
        const thumbEl = frame.querySelector('.fotorama__thumb');
        const thumbUrl = item.thumb || item.img;
        if (!thumbEl || !thumbUrl || thumbEl.querySelector('img')) return;
        const img = document.createElement('img');
        img.src = thumbUrl;
        img.alt = '';
        thumbEl.appendChild(img);
        thumbEl.classList.add('fotorama__loaded', 'fotorama__loaded--img');
      });
    }

    // Handle window resize to maintain thumbs navigation
    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        const nowMobile = window.innerWidth <= 768;
        if (fotorama) {
          fotorama.setOptions({
            nav: 'thumbs' // Keep thumbs on all screen sizes
          });
        }
      }, 250);
    });

    // Force vertical layout after initialization
    setTimeout(function() {
      const navWrap = $('.fotorama__nav-wrap');
      const nav = $('.fotorama__nav');
      const navShaft = $('.fotorama__nav .fotorama__nav__shaft');

      if (window.innerWidth > 768) {
        navWrap.css({
          'position': 'absolute',
          'top': '0',
          'right': '0',
          'bottom': 'auto',
          'left': 'auto',
          'width': '100px',
          'height': '100%',
          'overflow-y': 'auto',
          'overflow-x': 'hidden'
        });

        nav.css({
          'flex-direction': 'column',
          'height': 'auto',
          'width': '100%',
          'gap': '8px',
          'align-items': 'stretch',
          'justify-content': 'flex-start'
        });

        navShaft.css({
          'display': 'flex',
          'flex-direction': 'column',
          'width': '100%',
          'height': 'auto',
          'gap': '8px',
          'align-items': 'stretch'
        });

        // Force each thumbnail to be block level
        $('.fotorama__thumb').css({
          'display': 'block',
          'width': '100px',
          'height': '100px',
          'margin': '0',
          'flex-shrink': '0'
        });

        // Ensure thumbnail images are visible
        $('.fotorama__thumb img, .fotorama__thumb .fotorama__img').css({
          'width': '100%',
          'height': '100%',
          'object-fit': 'cover',
          'display': 'block',
          'opacity': '1',
          'visibility': 'visible'
        });

        // Force Fotorama to refresh/redraw thumbnails
        if (fotorama && fotorama.resize) {
          fotorama.resize();
        }

        // Additional fix: Force thumbnail images to load
        setTimeout(function() {
          $('.fotorama__thumb').each(function() {
            const $thumb = $(this);
            const $img = $thumb.find('img, .fotorama__img');

            if ($img.length && !$img.is(':visible')) {
              $img.css({
                'display': 'block',
                'opacity': '1',
                'visibility': 'visible'
              });
            }
          });
        }, 1000);
      }
    }, 100);

    $(document).on( "click", ".fotorama:not(.fotorama--fullscreen) .fotorama__stage__shaft .fotorama__active:not(.fotorama__stage__frame--video) img", function() {
      fotorama.show(fotorama.activeIndex-1)
      fotorama.requestFullScreen()
    });

    // Defensive fallback: fill in any still-blank thumbs as the user scrolls the nav
    $(document).on('scroll', '.fotorama__nav-wrap', function() {
      forceLoadNavThumbs();
    });

    fotoramaDiv.on('fotorama:ready', function() {
      forceLoadNavThumbs();
      // Additional layout enforcement after Fotorama is fully ready
      setTimeout(function() {
        forceLoadNavThumbs();
        if (window.innerWidth > 768) {
          const navWrap = $('.fotorama__nav-wrap');
          const nav = $('.fotorama__nav');
          const navShaft = $('.fotorama__nav .fotorama__nav__shaft');
          const navFrames = $('.fotorama__nav .fotorama__nav__frame');

          // Force vertical layout
          navShaft.css({
            'display': 'flex !important',
            'flex-direction': 'column !important',
            'width': '100% !important',
            'height': 'auto !important',
            'transform': 'none !important',
            'transition': 'none !important',
            'left': 'auto !important',
            'top': 'auto !important'
          });

          navFrames.css({
            'display': 'block !important',
            'width': '100% !important',
            'margin-bottom': '8px !important',
            'margin-right': '0 !important',
            'float': 'none !important'
          });

          // Ensure thumbnail images are visible
          $('.fotorama__thumb img, .fotorama__thumb .fotorama__img').css({
            'width': '100%',
            'height': '100%',
            'object-fit': 'cover',
            'display': 'block',
            'opacity': '1',
            'visibility': 'visible'
          });
        }
      }, 500);
    });

    fotoramaDiv.on('fotorama:showend',function (e, fotorama, extra) {
      $('.fotorama__stage__frame').removeClass('video-active-gallery');
      if ('video' in fotorama.activeFrame) {
        setTimeout(function() {
          fotorama.playVideo();
          $('.fotorama--fullscreen .fotorama__wrap').removeClass('fotorama__wrap--video');
          $('.fotorama--fullscreen .fotorama__stage__shaft .fotorama__active').addClass('video-active-gallery');
        }, 1000);
      }
    })

    fotoramaDiv.on('fotorama:fullscreenexit',function (e, fotorama, extra) {
      $('.fotorama__stage__frame').removeClass('video-active-gallery');
    })

    $('body').on('keyup', function (e) {
        if ($('.fotorama--fullscreen').length && e.which === 27) { // detect if it is **Esc** button
          $('.fotorama__stage__frame').removeClass('video-active-gallery');
          fotorama.cancelFullScreen()
        }
    });    // Handle window resize to maintain vertical thumbs layout
    $(window).on('resize', function() {
      const navWrap = $('.fotorama__nav-wrap');
      const nav = $('.fotorama__nav');
      const navShaft = $('.fotorama__nav .fotorama__nav__shaft');

      if (window.innerWidth > 768) {
        navWrap.css({
          'position': 'absolute',
          'top': '0',
          'right': '0',
          'bottom': 'auto',
          'left': 'auto',
          'width': '100px',
          'height': '90%',
          'overflow-y': 'auto',
          'overflow-x': 'hidden'
        });

        nav.css({
          'flex-direction': 'column',
          'height': 'auto',
          'width': '100%',
          'gap': '8px',
          'align-items': 'stretch',
          'justify-content': 'flex-start'
        });

        navShaft.css({
          'display': 'flex',
          'flex-direction': 'column',
          'width': '100%',
          'height': 'auto',
          'gap': '8px',
          'align-items': 'stretch'
        });

        // Force each thumbnail to be block level
        $('.fotorama__thumb').css({
          'display': 'block',
          'width': '100px',
          'height': '100px',
          'margin': '0',
          'flex-shrink': '0'
        });
      } else {
        // Reset to default on mobile
        navWrap.css({
          'position': '',
          'top': '',
          'right': '',
          'bottom': '',
          'left': '',
          'width': '',
          'height': '',
          'overflow-y': '',
          'overflow-x': ''
        });

        nav.css({
          'flex-direction': '',
          'height': '',
          'width': '',
          'gap': '',
          'align-items': '',
          'justify-content': ''
        });

        navShaft.css({
          'display': '',
          'flex-direction': '',
          'width': '',
          'height': '',
          'gap': '',
          'align-items': ''
        });

        $('.fotorama__thumb').css({
          'display': '',
          'width': '',
          'height': '',
          'margin': '',
          'flex-shrink': ''
        });
      }
    });
  });
}


document.querySelector("#subscriptionButton").addEventListener("click", function(){
  onSubscriptionClick(false);
}, false);

document.querySelector("#buyOnceButton").addEventListener("click", function(){
  onSubscriptionClick(true);
}, false);
setTimeout(function() {
onSubscriptionClick(true);
},500)
function onSubscriptionClick(isBuyOnceClicked) {
  const subscriptionList = document.getElementById("appstle-widget-template");
  const buyOnce = document.getElementById("buyOnceContainer");
  const subscriptionContainer = document.getElementById("subscriptionContainer");
  const style = window.getComputedStyle(subscriptionList)

  const allSubscriptions = document.getElementsByClassName("appstle_input_wrapper")
  const priceElement = document.querySelector('.product-price--original[data-js-product-price-original]');
  const priceElementCustom = document.querySelector('.product-price--original-custom[data-js-product-price-original]');
  const metaPriceElement = document.querySelector('meta[property="og:price:amount_cents"]');
  const appstleInputProperty = document.querySelector('input[id="appstle_selling_plan_property"]');
  const defaultPrice = parseFloat(metaPriceElement.getAttribute('content'));

  if (!isBuyOnceClicked && style.getPropertyValue('display') == 'none') {
    buyOnce.classList.remove('active');
    subscriptionContainer.classList.add('active')
    subscriptionList.style.display = "block";
    allSubscriptions[1].getElementsByTagName("input")[0].click()
    const newPrice = (defaultPrice * 0.90);
    priceElement.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
    const sellingPlanId = document.querySelector('input[name="selling_plan"]:checked').value;
    if(appstleInputProperty) {
      appstleInputProperty.name = "properties[__appstle-selected-selling-plan]";
      appstleInputProperty.value = sellingPlanId;
    }
  } else {
    subscriptionList.style.display = "none";
    buyOnce.classList.add('active');
    subscriptionContainer.classList.remove('active')
    allSubscriptions[0].getElementsByTagName("input")[0].click()
    priceElement.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
    if(appstleInputProperty) {
      appstleInputProperty.name = ""; // Clear the name
      appstleInputProperty.value = ""; // Clear the value
    }
  }
}